import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/creators/{creatorSlug}/members/{personId}/conversation']['GET'];
type Input = ThisApi['params'];
type Output = ThisApi['response'];

const getMemberConversation = async ({ creatorSlug, personId }: Input): Promise<Output> => {
  const path = buildPath<ThisApi>('/creators/{creatorSlug}/members/{personId}/conversation', { creatorSlug, personId });
  const response = await noodleApiClient.get(path);
  return response.data;
};

export default getMemberConversation;
